module.exports = __webpack_public_path__ + "media/videoAirDuTemp.ade542de.mp4";